exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.node[data-v-4d8c1a28] {\n  padding-left: 10px;\n  margin-bottom: 2px;\n}\n.folder[data-v-4d8c1a28] {\n  color: #903307;\n}\n.node-text[data-v-4d8c1a28] {\n  font-size: 1.1rem;\n}\n.cont[data-v-4d8c1a28] {\n  -webkit-padding-start: 10px;\n          padding-inline-start: 10px;\n}\n.cont li[data-v-4d8c1a28] {\n  list-style-type: none;\n}\n", ""]);

// exports
